// extracted by mini-css-extract-plugin
export default {"cls1":"Cta-cls1__d0305f865cb621571055","cls2":"Cta-cls2__d83ccf7fae97d4f6618f Cta-cls1__d0305f865cb621571055"};